import { t } from "app/utils";

export const IMAGE_TYPE = "image";
export const VIDEO_TYPE = "video";
export const AUDIO_TYPE = "audio";
export const TEXT_TYPE = "text";
export const IMAGE_SLIDE_DURATION = 5;

export const STORY_TRANSITION_TIME = 0.487;
export const IRC_TEXT_DELAY = 1.35;
export const IRC_TEXT_DURATION = 5;

export const ELEMENT_NAMES = {
  ACTIVISION_PRIDE: "Activision Pride + Trans Flag",
  ASSURANT_BLACK_LOGO: "assurant_black_logo",
  ASSURANT_COLOR_LOGO: "assurant_color_logo",
  ASSURANT_WHITE_LOGO: "assurant_white_logo",
  BACKGROUND_V_INTRO: "background_video_intro",
  BLACK_OUTRO: "black_outro",
  BOTTOM_CIRCLE: "bottom_circle",
  BOTTOM_LEFT_IMAGE: "bottom_left_image",
  CAPTION: "caption",
  CAPTION1: "Caption 1",
  CAPTION2: "Caption 2",
  CAPTION3: "Caption 3",
  COMPANY_LOGO: "company_logo",
  COMPANY_LOGO_BLANK: "Company Logo",
  COMPANY_LOGO_INTRO: "company_logo_intro",
  COMPANY_LOGO_OUTRO: "company_logo_outro",
  COMPANYNAME: "Company Name",
  COOL_GRADIENT: "cool_gradient",
  DEPARTMENT: "department",
  DEPARTMENT_1: "department_1",
  DEPARTMENT_2: "department_2",
  DEPARTMENT_3: "department_3",
  FIRST_STORY: "First Story",
  ILEG_OVERLAY: "ileg_overlay",
  INTRO: "Intro",
  INTRO_CIRCLE: "intro circle",
  INTRO_HEADER: "Intro - Header",
  INTUITIVE_INTRO: "intuitive_intro",
  INTUITVE_LOGO_WHITE: "intuitive_logo_white",
  INTUITIVE_OUTRO: "intuitive_outro",
  LARGE_OVERLAY: "Large Overlay",
  LARGE_OVERLAY_1: "Large_Overlay_1",
  LARGE_OVERLAY_2: "Large_Overlay_2",
  LARGE_OVERLAY_3: "Large_Overlay_3",
  LAST_STORY: "Last Story",
  LOCATION: "location",
  LOCATION_1: "location_1",
  LOCATION_2: "location_2",
  LOCATION_3: "location_3",
  LOCATION_BLANK_OVERLAY: "location overlay",
  LOGO_INTRO: "Logo Intro",
  LOGO_OUTRO: "Logo Outro",
  LOWER_TH_OVERLAY: "Lower Thirds Overlay",
  MERCK_WHITE_LOGO: "merck_white_logo",
  MERCK_LOGO_WHITE: "merck_logo_white",
  NAME: "name",
  NAME1: "Name 1",
  NAME2: "Name 2",
  NAME3: "Name 3",
  NAME_0: "name_0",
  NAME_1: "name_1",
  NAME_2: "name_2",
  NAME_3: "name_3",
  NAME_AND_TITLE: "name_and_title",
  NAME_AND_TITLE_BLANK: "Name and Title",
  NAME_AND_TITLE_1: "name_and_title_overlay_1",
  NAME_AND_TITLE_2: "name_and_title_overlay_2",
  NAME_AND_TITLE_3: "name_and_title_overlay_3",
  NAME_AND_TITLE_4: "name_and_title_overlay_4",
  NAME_AND_TITLE_OVERLAY: "name_and_title_overlay",
  NAME_OVERLAY: "name_overlay",
  NAME_OVERLAY_0: "name_overlay_0",
  NAME_OVERLAY_1: "name_overlay_1",
  NAME_BLANK_OVERLAY: "name overlay",
  OUTRO: "Outro",
  OUTRO_ANIMATION: "outro_animation",
  OUTRO_HASHTAGS: "Outro - Hashtags",
  OUTRO_HEADER: "Outro - Header",
  OUTRO_IRC_LOGO: "Outro - IRC Logo",
  OUTRO_TEXT: "Outro - Text",
  OVERLAY: "overlay",
  OVERLAY_LINE: "overlay_line",
  OVERLAY_LINE_0: "overlay_line_0",
  OVERLAY_LINE_1: "overlay_line_1",
  PREMISE_HEALTH_LOGO: "premise health white logo",
  PREMISE_HEALTH_OUTRO_BACKGROUND: "outro background",
  PRIMARY_GRADIENT: "primary_gradient",
  PROFILE_PIC: "profile_pic",
  PROFILE_PIC1: "Profile Pic 1",
  PROFILE_PIC2: "Profile Pic 2",
  PROFILE_PIC3: "Profile Pic 3",
  PROFILE_PIC_BLANK: "Profile Pic",
  PROMPT: "prompt",
  PROMPTGO: "Prompt Gradient Overlay",
  PURPLEGO: "Purple Gradient Overlay",
  QUOTE_IMAGE: "quote_image",
  RED_LOGO_OUTRO: "red_logo_outro",
  RED_WDMK_LOGO_OUTRO: "red_wordmark_logo_outro",
  RECOGNITION_WEEK_OVERLAY: "Recognition_Week_Overlay",
  STORY: "story",
  STORY1: "story 1",
  STORY2: "story 2",
  STORY3: "story 3",
  STORY_0: "story_0",
  STORY_1: "story_1",
  STORY_TREND: "story_trend",
  STORY_TREND_BLANK: "Story Trend",
  SMALL_OVERLAY: "Small Overlay",
  SMALL_OVERLAY_1: "Small_Overlay_1",
  SMALL_OVERLAY_2: "Small_Overlay_2",
  SMALL_OVERLAY_3: "Small_Overlay_3",
  TEAL_OVERLAY: "teal_overlay",
  TEXT_COULD: "text_could",
  TEXT_JOIN: "text_join",
  TEXT_OVERLAY: "text_overlay",
  TITLE: "title",
  TITLE_0: "title_0",
  TITLE_1: "title_1",
  TITLE_2: "title_2",
  TITLE_3: "title_3",
  TITLE_OVERLAY: "title_overlay",
  TITLE_OVERLAY_0: "title_overlay_0",
  TITLE_OVERLAY_1: "title_overlay_1",
  TITLE_BLANK_OVERLAY: "title overlay",
  TITLE_UNDERLINE: "title_underline",
  TOP_CIRCLE: "top_cirle",
  TOP_RIGHT_IMAGE: "top_right_image",
  VERIZON_LOGO_WHITE: "verizon_logo_white",
  WARM_GRADIENT: "warm_gradient",
  WHITE_OUTRO: "white_outro",
  WHITE_LOGO_OUTRO: "white_logo_outro",
  WHITE_WDMK_LOGO_OUTRO: "white_wordmark_logo_outro",
  ZENDESK_OUTRO: "zendesk_outro"
} as const;

export const ANIMATIONS = {
  NONE: "none",
  BOUNCE: "bounce",
  CIRCULAR_WIPE: "circular-wipe",
  COLOR_WIPE: "color-wipe",
  FADE: "fade",
  FILM_ROLL: "film-roll",
  FLIP: "flip",
  PAN: "pan",
  ROTATE_SLIDE: "rotate-slide",
  SCALE: "scale",
  POP: "pop",
  SHIFT: "shift",
  SLIDE: "slide",
  FLOAT: "float",
  SPIN: "spin",
  SQUASH: "squash",
  STRIPE: "stripe",
  WIPE: "wipe",
  WIGGLE: "wiggle",
  TEXT_APPEAR: "text-appear",
  TEXT_COUNTER: "text-counter",
  TEXT_FLY: "text-fly",
  TEXT_REVEAL: "text-reveal",
  TEXT_SCALE: "text-scale",
  TEXT_SLIDE: "text-slide",
  TEXT_SPIN: "text-spin",
  TEXT_TYPEWRITER: "text-typewriter",
  TEXT_WAVE: "text-wave"
};

export const ANIMATION_SUBTYPES = {
  TOP_LEFT: "Top Left",
  TOP_RIGHT: "Top Right",
  BOTTOM_LEFT: "Bottom Left",
  BOTTOM_RIGHT: "Bottom Right",
  X_AXIS: "X Axis",
  Y_AXIS: "Y Axis",
  X_AXIS_LEFT: "X Axis left",
  X_AXIS_RIGHT: "X Axis right",
  Y_AXIS_UP: "Y Axis up",
  Y_AXIS_DOWN: "Y Axis down",
  LEFT: "Left",
  RIGHT: "Right",
  UP: "Up",
  DOWN: "Down",
  LEFT_UP: "Left Up",
  LEFT_DOWN: "Left Down",
  RIGHT_UP: "Right Up",
  RIGHT_DOWN: "Right Down",
  UP_LEFT: "Up Left",
  UP_RIGHT: "Up Right",
  DOWN_LEFT: "Down Left",
  DOWN_RIGHT: "Down Right",
  PAGE: "Page",
  CENTER: "Center",
  CENTER_HORIZONTAL: "Center horizontal",
  CENTER_VERTICAL: "Center vertical",
  CORNER: "Corner",
  LARGER: "Larger",
  SHOCKWAVE: "Shockwave",
  IN: "In",
  LEFT_WITH_ZOOM: "Left with zoom",
  RIGHT_WITH_ZOOM: "Right with zoom",
  UP_WITH_ZOOM: "Up with zoom",
  DOWN_WITH_ZOOM: "Down with zoom",
  CLOCKWISE: "Clockwise",
  COUNTER_CLOCKWISE: "Counter Clockwise",
  CENTER_X_AXIS: "Center X axis",
  CENTER_Y_AXIS: "Center Y axis",
  DIAGONAL: "Diagonal",
  ROTATING: "Rotating",
  SINGLE: "Single",
  MULTIPLE_AXES: "Multiple axes",
  LINE_BY_LINE: "Line by line",
  WORD_BY_WORD: "Word by word",
  LETTER_BY_LETTER: "Letter by letter",
  LINE_BY_LINE_RANDOMLY: "Line by line randomly",
  WORD_BY_WORD_RANDOMLY: "Word by word randomly",
  LETTER_BY_LETTER_RANDOMLY: "Letter by letter randomly",
  LETTER_BY_LETTER_ALTERNATIVE: "Letter by letter alternative",
  LONG_WAVELENGTH: "Long wavelength",
  LINE_BY_LINE_HIGHLIGHTING: "Line by line highlighting",
  WORD_BY_WORD_HIGHLIGHTING: "Word by word highlighting",
  LETTER_BY_LETTER_HIGHLIGHTING: "Letter by letter highlighting",
  COUNT_UP: "Count up",
  COUNT_DOWN: "Count down",
  UP_LINE_BY_LINE: "Up line by line",
  DOWN_LINE_BY_LINE: "Down line by line",
  LEFT_LINE_BY_LINE: "Left line by line",
  RIGHT_LINE_BY_LINE: "Right line by line",
  UP_WORD_BY_WORD: "Up word by word",
  DOWN_WORD_BY_WORD: "Down word by word",
  LEFT_WORD_BY_WORD: "Left word by word",
  RIGHT_WORD_BY_WORD: "Right word by word",
  UP_LETTER_BY_LETTER: "Up letter by letter",
  DOWN_LETTER_BY_LETTER: "Down letter by letter",
  LEFT_LETTER_BY_LETTER: "Left letter by letter",
  RIGHT_LETTER_BY_LETTER: "Right letter by letter",
  UP_LINE_BY_LINE_CLIPPED: "Up line by line clipped",
  DOWN_LINE_BY_LINE_CLIPPED: "Down line by line clipped",
  LEFT_LINE_BY_LINE_CLIPPED: "Left line by line clipped",
  RIGHT_LINE_BY_LINE_CLIPPED: "Right line by line clipped",
  UP_WORD_BY_WORD_CLIPPED: "Up word by word clipped",
  DOWN_WORD_BY_WORD_CLIPPED: "Down word by word clipped",
  LEFT_WORD_BY_WORD_CLIPPED: "Left word by word clipped",
  RIGHT_WORD_BY_WORD_CLIPPED: "Right word by word clipped",
  UP_LETTER_BY_LETTER_CLIPPED: "Up letter by letter clipped",
  DOWN_LETTER_BY_LETTER_CLIPPED: "Down letter by letter clipped",
  LEFT_LETTER_BY_LETTER_CLIPPED: "Left letter by letter clipped",
  RIGHT_LETTER_BY_LETTER_CLIPPED: "Right letter by letter clipped",
  QUADRATIC: "Quadratic",
  ELASTIC: "Elastic",
  RANDOM_ELASTIC: "Random elastic",
  TYPEWRITING: "Typewriting",
  TYPEWRITING_FIXED_DURATION: "Typewriting fixed duration",
  POP: "Pop",
  FLOAT: "Float"
};

export const FITS = [
  { label: t("Cover"), value: "cover" },
  { label: t("Contain"), value: "contain" },
  { label: t("Fill"), value: "fill" }
];

export const GENERIC_ANIMATIONS = [
  { label: t("Circular Wipe"), value: ANIMATIONS.CIRCULAR_WIPE },
  { label: t("Color Wipe"), value: ANIMATIONS.COLOR_WIPE },
  { label: t("Fade"), value: ANIMATIONS.FADE },
  { label: t("Flip"), value: ANIMATIONS.FLIP },
  { label: t("Rotate Slide"), value: ANIMATIONS.ROTATE_SLIDE },
  { label: t("Scale"), value: ANIMATIONS.SCALE },
  { label: t("Pop"), value: ANIMATIONS.POP },
  { label: t("Slide"), value: ANIMATIONS.SLIDE },
  { label: t("Float"), value: ANIMATIONS.FLOAT },
  { label: t("Spin"), value: ANIMATIONS.SPIN },
  { label: t("Squash"), value: ANIMATIONS.SQUASH },
  { label: t("Wipe"), value: ANIMATIONS.WIPE }
];

export const COLOR_FILTER = [
  { label: t("None"), value: "none" },
  { label: t("Brighten"), value: "brighten" },
  { label: t("Contrast"), value: "contrast" },
  { label: t("Invert"), value: "invert" },
  { label: t("Grayscale"), value: "grayscale" },
  { label: t("Sepia"), value: "sepia" }
];

export const TEXT_ANIMATIONS = [
  { label: t("Text Appear"), value: ANIMATIONS.TEXT_APPEAR },
  { label: t("Text Counter"), value: ANIMATIONS.TEXT_COUNTER },
  { label: t("Text Fly"), value: ANIMATIONS.TEXT_FLY },
  { label: t("Text Reveal"), value: ANIMATIONS.TEXT_REVEAL },
  { label: t("Text Scale"), value: ANIMATIONS.TEXT_SCALE },
  { label: t("Text Slide"), value: ANIMATIONS.TEXT_SLIDE },
  { label: t("Text Spin"), value: ANIMATIONS.TEXT_SPIN },
  { label: t("Text Typewriter"), value: ANIMATIONS.TEXT_TYPEWRITER },
  { label: t("Text Wave"), value: ANIMATIONS.TEXT_WAVE },
  ...GENERIC_ANIMATIONS
];

export const DEFAULT_ANIMATION_SETTINGS: Record<string, Record<string, any>> = {
  [ANIMATIONS.NONE]: {},
  [ANIMATIONS.BOUNCE]: {
    [ANIMATION_SUBTYPES.TOP_LEFT]: {
      time: 0.999,
      duration: 1,
      easing: "linear",
      x_anchor: "0%",
      y_anchor: "0%"
    },
    [ANIMATION_SUBTYPES.TOP_RIGHT]: {
      time: 0.999,
      duration: 1,
      easing: "linear",
      x_anchor: "100%",
      y_anchor: "0%"
    },
    [ANIMATION_SUBTYPES.BOTTOM_LEFT]: {
      time: 0.999,
      duration: 1,
      easing: "linear",
      x_anchor: "0%",
      y_anchor: "100%"
    },
    [ANIMATION_SUBTYPES.BOTTOM_RIGHT]: {
      time: 0.999,
      duration: 1,
      easing: "linear",
      x_anchor: "100%",
      y_anchor: "100%"
    },
    [ANIMATION_SUBTYPES.X_AXIS]: {
      time: 0.999,
      duration: 1,
      easing: "linear",
      axis: "x"
    },
    [ANIMATION_SUBTYPES.Y_AXIS]: {
      time: 0.999,
      duration: 1,
      easing: "linear",
      axis: "y"
    }
  },
  [ANIMATIONS.CIRCULAR_WIPE]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "100%"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "0%"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      y_anchor: "100%"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      y_anchor: "0%"
    },
    [ANIMATION_SUBTYPES.CENTER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out"
    },
    [ANIMATION_SUBTYPES.SHOCKWAVE]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      ring_color: "rgba(255, 255, 255, 0.5)",
      ring_width: "50%"
    }
  },
  [ANIMATIONS.COLOR_WIPE]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "left"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "right"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "up"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "down"
    }
  },
  [ANIMATIONS.FADE]: {
    [ANIMATION_SUBTYPES.IN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out"
    }
  },
  [ANIMATIONS.FILM_ROLL]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "left"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "right"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "up"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "down"
    }
  },
  [ANIMATIONS.FLIP]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_rotation: "0°",
      y_rotation: "-180°"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_rotation: "0°",
      y_rotation: "180°"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_rotation: "180°",
      y_rotation: "0°"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_rotation: "-180°",
      y_rotation: "0°"
    },
    [ANIMATION_SUBTYPES.UP_LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_rotation: "90°",
      y_rotation: "-90°"
    },
    [ANIMATION_SUBTYPES.UP_RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_rotation: "90°",
      y_rotation: "90°"
    },
    [ANIMATION_SUBTYPES.DOWN_LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_rotation: "-90°",
      y_rotation: "-90°"
    },
    [ANIMATION_SUBTYPES.DOWN_RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_rotation: "-90°",
      y_rotation: "90°"
    },
    [ANIMATION_SUBTYPES.PAGE]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_rotation: "0°",
      y_rotation: "90°",
      x_anchor: "0%",
      fade: false
    }
  },
  [ANIMATIONS.PAN]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      scope: "element",
      start_x: "100%",
      start_y: "50%",
      end_x: "0%",
      end_y: "50%"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      scope: "element",
      start_x: "0%",
      start_y: "50%",
      end_x: "100%",
      end_y: "50%"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      scope: "element",
      start_x: "50%",
      start_y: "100%",
      end_x: "50%",
      end_y: "0%"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      scope: "element",
      start_x: "50%",
      start_y: "0%",
      end_x: "50%",
      end_y: "100%"
    },
    [ANIMATION_SUBTYPES.LEFT_WITH_ZOOM]: {
      time: 0,
      duration: 1,
      scope: "element",
      start_x: "100%",
      start_y: "50%",
      start_scale: "100%",
      end_x: "0%",
      end_y: "50%",
      end_scale: "150%"
    },
    [ANIMATION_SUBTYPES.RIGHT_WITH_ZOOM]: {
      time: 0,
      duration: 1,
      scope: "element",
      start_x: "0%",
      start_y: "50%",
      start_scale: "100%",
      end_x: "100%",
      end_y: "50%",
      end_scale: "150%"
    },
    [ANIMATION_SUBTYPES.UP_WITH_ZOOM]: {
      time: 0,
      duration: 1,
      scope: "element",
      start_x: "50%",
      start_y: "100%",
      start_scale: "100%",
      end_x: "50%",
      end_y: "0%",
      end_scale: "150%"
    },
    [ANIMATION_SUBTYPES.DOWN_WITH_ZOOM]: {
      time: 0,
      duration: 1,
      scope: "element",
      start_x: "50%",
      start_y: "0%",
      start_scale: "100%",
      end_x: "50%",
      end_y: "100%",
      end_scale: "150%"
    }
  },
  [ANIMATIONS.ROTATE_SLIDE]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "left",
      clockwise: true
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "right",
      clockwise: true
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "up",
      clockwise: true
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "down",
      clockwise: true
    }
  },
  [ANIMATIONS.SCALE]: {
    [ANIMATION_SUBTYPES.CENTER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "50%",
      y_anchor: "50%"
    },
    [ANIMATION_SUBTYPES.LARGER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      scope: "element",
      start_scale: "100%",
      end_scale: "150%",
      x_anchor: "50%",
      y_anchor: "50%"
    },
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "100%",
      y_anchor: "50%",
      axis: "both" },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "0%",
      y_anchor: "50%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "50%",
      y_anchor: "100%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "50%",
      y_anchor: "0%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.LEFT_UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "100%",
      y_anchor: "100%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.LEFT_DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "100%",
      y_anchor: "0%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.RIGHT_UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "0%",
      y_anchor: "100%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.RIGHT_DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "0%",
      y_anchor: "0%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.X_AXIS_LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "100%",
      y_anchor: "50%",
      axis: "x"
    },
    [ANIMATION_SUBTYPES.X_AXIS_RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "0%",
      y_anchor: "50%",
      axis: "x"
    },
    [ANIMATION_SUBTYPES.Y_AXIS_UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "50%",
      y_anchor: "100%",
      axis: "y"
    },
    [ANIMATION_SUBTYPES.Y_AXIS_DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "50%",
      y_anchor: "0%",
      axis: "y"
    }
  },
  [ANIMATIONS.POP]: {
    [ANIMATION_SUBTYPES.CENTER]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "50%",
      y_anchor: "50%"
    },
    [ANIMATION_SUBTYPES.LARGER]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      scope: "element",
      start_scale: "100%",
      end_scale: "150%",
      x_anchor: "50%",
      y_anchor: "50%"
    },
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "100%",
      y_anchor: "50%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "0%",
      y_anchor: "50%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "50%",
      y_anchor: "100%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "50%",
      y_anchor: "0%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.LEFT_UP]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "100%",
      y_anchor: "100%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.LEFT_DOWN]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "100%",
      y_anchor: "0%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.RIGHT_UP]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "0%",
      y_anchor: "100%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.RIGHT_DOWN]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "0%",
      y_anchor: "0%",
      axis: "both"
    },
    [ANIMATION_SUBTYPES.X_AXIS_LEFT]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "100%",
      y_anchor: "50%",
      axis: "x"
    },
    [ANIMATION_SUBTYPES.X_AXIS_RIGHT]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "0%",
      y_anchor: "50%",
      axis: "x"
    },
    [ANIMATION_SUBTYPES.Y_AXIS_UP]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "50%",
      y_anchor: "100%",
      axis: "y"
    },
    [ANIMATION_SUBTYPES.Y_AXIS_DOWN]: {
      time: 0,
      duration: 1,
      easing: "elastic-in-out",
      x_anchor: "50%",
      y_anchor: "0%",
      axis: "y"
    }
  },
  [ANIMATIONS.SHIFT]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      direction: "left"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      direction: "right"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      direction: "up"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      direction: "down"
    }
  },
  [ANIMATIONS.SLIDE]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "180°"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "0°"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "90°"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "270°"
    },
    [ANIMATION_SUBTYPES.LEFT_UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "135°"
    },
    [ANIMATION_SUBTYPES.RIGHT_UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "45°"
    },
    [ANIMATION_SUBTYPES.LEFT_DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "225°"
    },
    [ANIMATION_SUBTYPES.RIGHT_DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "315°"
    }
  },
  [ANIMATIONS.FLOAT]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 0.5,
      easing: "quadratic-out",
      direction: "180°",
      distance: "20%"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 0.5,
      easing: "quadratic-out",
      direction: "0°",
      distance: "20%"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 0.5,
      easing: "quadratic-out",
      direction: "90°",
      distance: "20%"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 0.5,
      easing: "quadratic-out",
      direction: "270°",
      distance: "20%"
    },
    [ANIMATION_SUBTYPES.LEFT_UP]: {
      time: 0,
      duration: 0.5,
      easing: "quadratic-out",
      direction: "135°",
      distance: "20%"
    },
    [ANIMATION_SUBTYPES.RIGHT_UP]: {
      time: 0,
      duration: 0.5,
      easing: "quadratic-out",
      direction: "45°",
      distance: "20%"
    },
    [ANIMATION_SUBTYPES.LEFT_DOWN]: {
      time: 0,
      duration: 0.5,
      easing: "quadratic-out",
      direction: "225°",
      distance: "20%"
    },
    [ANIMATION_SUBTYPES.RIGHT_DOWN]: {
      time: 0,
      duration: 0.5,
      easing: "quadratic-out",
      direction: "315°",
      distance: "20%"
    }
  },
  [ANIMATIONS.SPIN]: {
    [ANIMATION_SUBTYPES.CLOCKWISE]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      rotation: "360°"
    },
    [ANIMATION_SUBTYPES.COUNTER_CLOCKWISE]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      rotation: "-360°"
    },
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      scope: "composition",
      rotation: "-22.5°",
      x_anchor: "0%",
      y_anchor: "50%"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      scope: "composition",
      rotation: "22.5°",
      x_anchor: "100%",
      y_anchor: "50%"
    }
  },
  [ANIMATIONS.SQUASH]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "left"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "right"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "up"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "down"
    }
  },
  [ANIMATIONS.STRIPE]: {},
  [ANIMATIONS.WIPE]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "100%"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "0%"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "0%",
      start_angle: "90°",
      end_angle: "90°"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "0%",
      start_angle: "270°",
      end_angle: "270°"
    },
    [ANIMATION_SUBTYPES.CENTER_X_AXIS]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "50%",
      start_angle: "0°",
      end_angle: "0°"
    },
    [ANIMATION_SUBTYPES.CENTER_Y_AXIS]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "50%",
      start_angle: "90°",
      end_angle: "90°"
    },
    [ANIMATION_SUBTYPES.DIAGONAL]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      start_angle: "45°",
      end_angle: "45°"
    },
    [ANIMATION_SUBTYPES.ROTATING]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      x_anchor: "50%",
      start_angle: "90°",
      end_angle: "0°"
    }
  },
  [ANIMATIONS.WIGGLE]: {
    [ANIMATION_SUBTYPES.SINGLE]: {
      time: 0,
      duration: 1,
      easing: "linear"
    },
    [ANIMATION_SUBTYPES.MULTIPLE_AXES]: {
      time: 0,
      duration: 1,
      easing: "linear",
      x_angle: "20°",
      y_angle: "20°",
      z_angle: "10°"
    },
    [ANIMATION_SUBTYPES.X_AXIS]: {
      time: 0,
      duration: 1,
      easing: "linear",
      x_angle: "20°",
      z_angle: "0°"
    },
    [ANIMATION_SUBTYPES.Y_AXIS]: {
      time: 0,
      duration: 1,
      easing: "linear",
      y_angle: "20°",
      z_angle: "0°"
    }
  },
  [ANIMATIONS.TEXT_APPEAR]: {
    [ANIMATION_SUBTYPES.LINE_BY_LINE]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line"
    },
    [ANIMATION_SUBTYPES.WORD_BY_WORD]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "word"
    },
    [ANIMATION_SUBTYPES.LETTER_BY_LETTER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter"
    },
    [ANIMATION_SUBTYPES.LINE_BY_LINE_RANDOMLY]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      order: "random"
    },
    [ANIMATION_SUBTYPES.WORD_BY_WORD_RANDOMLY]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "word",
      order: "random"
    },
    [ANIMATION_SUBTYPES.LETTER_BY_LETTER_RANDOMLY]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter",
      order: "random"
    },
    [ANIMATION_SUBTYPES.LINE_BY_LINE_HIGHLIGHTING]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      start_opacity: "20%"
    },
    [ANIMATION_SUBTYPES.WORD_BY_WORD_HIGHLIGHTING]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "word",
      start_opacity: "20%"
    },
    [ANIMATION_SUBTYPES.LETTER_BY_LETTER_HIGHLIGHTING]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter",
      start_opacity: "20%"
    }
  },
  [ANIMATIONS.TEXT_COUNTER]: {
    [ANIMATION_SUBTYPES.COUNT_UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out"
    },
    [ANIMATION_SUBTYPES.COUNT_DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "down"
    }
  },
  [ANIMATIONS.TEXT_FLY]: {
    [ANIMATION_SUBTYPES.LINE_BY_LINE]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line"
    },
    [ANIMATION_SUBTYPES.WORD_BY_WORD]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "word"
    },
    [ANIMATION_SUBTYPES.LETTER_BY_LETTER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter"
    }
  },
  [ANIMATIONS.TEXT_REVEAL]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      axis: "x",
      x_anchor: "100%"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      axis: "x",
      x_anchor: "0%"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      axis: "y",
      y_anchor: "100%"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      axis: "y",
      y_anchor: "0%"
    },
    [ANIMATION_SUBTYPES.CENTER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line"
    },
    [ANIMATION_SUBTYPES.CENTER_HORIZONTAL]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      axis: "x"
    },
    [ANIMATION_SUBTYPES.CENTER_VERTICAL]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      axis: "y"
    },
    [ANIMATION_SUBTYPES.CORNER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      x_anchor: "0%",
      y_anchor: "100%"
    }
  },
  [ANIMATIONS.TEXT_SCALE]: {
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      axis: "x",
      x_anchor: "100%"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      axis: "x",
      x_anchor: "0%"
    },
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      axis: "y",
      y_anchor: "100%"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      axis: "y",
      y_anchor: "0%"
    },
    [ANIMATION_SUBTYPES.CENTER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line"
    },
    [ANIMATION_SUBTYPES.CENTER_HORIZONTAL]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      axis: "x"
    },
    [ANIMATION_SUBTYPES.CENTER_VERTICAL]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      axis: "y"
    },
    [ANIMATION_SUBTYPES.CORNER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      x_anchor: "0%",
      y_anchor: "100%"
    }
  },
  [ANIMATIONS.TEXT_SLIDE]: {
    [ANIMATION_SUBTYPES.UP_LINE_BY_LINE]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "up",
      split: "line",
      scope: "element",
      distance: "200%",
      background_effect: "disabled"
    },
    [ANIMATION_SUBTYPES.DOWN_LINE_BY_LINE]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "down",
      split: "line",
      scope: "element",
      distance: "200%",
      background_effect: "disabled"
    },
    [ANIMATION_SUBTYPES.LEFT_LINE_BY_LINE]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "left",
      split: "line",
      scope: "element",
      distance: "200%",
      background_effect: "disabled"
    },
    [ANIMATION_SUBTYPES.RIGHT_LINE_BY_LINE]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "right",
      split: "line",
      scope: "element",
      distance: "200%",
      background_effect: "disabled"
    },
    [ANIMATION_SUBTYPES.UP_WORD_BY_WORD]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "up",
      split: "word",
      scope: "element",
      distance: "200%",
      background_effect: "disabled"
    },
    [ANIMATION_SUBTYPES.DOWN_WORD_BY_WORD]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "down",
      split: "word",
      scope: "element",
      distance: "200%",
      background_effect: "disabled"
    },
    [ANIMATION_SUBTYPES.LEFT_WORD_BY_WORD]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "left",
      split: "word",
      scope: "element",
      distance: "200%",
      background_effect: "disabled"
    },
    [ANIMATION_SUBTYPES.RIGHT_WORD_BY_WORD]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "right",
      split: "word",
      scope: "element",
      distance: "200%",
      background_effect: "disabled"
    },
    [ANIMATION_SUBTYPES.UP_LETTER_BY_LETTER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "up",
      split: "letter",
      scope: "element",
      distance: "200%",
      background_effect: "disabled"
    },
    [ANIMATION_SUBTYPES.DOWN_LETTER_BY_LETTER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "down",
      split: "letter",
      scope: "element",
      distance: "200%",
      background_effect: "disabled"
    },
    [ANIMATION_SUBTYPES.LEFT_LETTER_BY_LETTER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "left",
      split: "letter",
      scope: "element",
      distance: "200%",
      background_effect: "disabled"
    },
    [ANIMATION_SUBTYPES.RIGHT_LETTER_BY_LETTER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "right",
      split: "letter",
      scope: "element",
      distance: "200%",
      background_effect: "disabled"
    },
    [ANIMATION_SUBTYPES.UP_LINE_BY_LINE_CLIPPED]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "up",
      split: "line",
      scope: "split-clip"
    },
    [ANIMATION_SUBTYPES.DOWN_LINE_BY_LINE_CLIPPED]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "down",
      split: "line",
      scope: "split-clip"
    },
    [ANIMATION_SUBTYPES.LEFT_LINE_BY_LINE_CLIPPED]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "left",
      split: "line",
      scope: "split-clip"
    },
    [ANIMATION_SUBTYPES.RIGHT_LINE_BY_LINE_CLIPPED]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "right",
      split: "line",
      scope: "split-clip"
    },
    [ANIMATION_SUBTYPES.UP_WORD_BY_WORD_CLIPPED]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "up",
      split: "word",
      scope: "split-clip"
    },
    [ANIMATION_SUBTYPES.DOWN_WORD_BY_WORD_CLIPPED]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "down",
      split: "word",
      scope: "split-clip"
    },
    [ANIMATION_SUBTYPES.LEFT_WORD_BY_WORD_CLIPPED]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "left",
      split: "word",
      scope: "split-clip"
    },
    [ANIMATION_SUBTYPES.RIGHT_WORD_BY_WORD_CLIPPED]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "right",
      split: "word",
      scope: "split-clip"
    },
    [ANIMATION_SUBTYPES.UP_LETTER_BY_LETTER_CLIPPED]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "up",
      split: "letter",
      scope: "split-clip"
    },
    [ANIMATION_SUBTYPES.DOWN_LETTER_BY_LETTER_CLIPPED]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "down",
      split: "letter",
      scope: "split-clip"
    },
    [ANIMATION_SUBTYPES.LEFT_LETTER_BY_LETTER_CLIPPED]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "left",
      split: "letter",
      scope: "split-clip"
    },
    [ANIMATION_SUBTYPES.RIGHT_LETTER_BY_LETTER_CLIPPED]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      direction: "right",
      split: "letter",
      scope: "split-clip"
    }
  },
  [ANIMATIONS.TEXT_SPIN]: {
    [ANIMATION_SUBTYPES.UP]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter",
      direction: "up"
    },
    [ANIMATION_SUBTYPES.DOWN]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter",
      direction: "down"
    },
    [ANIMATION_SUBTYPES.LEFT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter",
      direction: "left"
    },
    [ANIMATION_SUBTYPES.RIGHT]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter",
      direction: "right"
    },
    [ANIMATION_SUBTYPES.QUADRATIC]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter",
      distance: "0%",
      rotation: "360°"
    },
    [ANIMATION_SUBTYPES.ELASTIC]: {
      time: 0,
      duration: 1,
      easing: "elastic-out",
      split: "letter",
      distance: "200%",
      direction: "down"
    },
    [ANIMATION_SUBTYPES.RANDOM_ELASTIC]: {
      time: 0,
      duration: 1,
      easing: "elastic-out",
      split: "letter",
      distance: "200%",
      direction: "down",
      order: "random"
    }
  },
  [ANIMATIONS.TEXT_TYPEWRITER]: {
    [ANIMATION_SUBTYPES.TYPEWRITING]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out"
    },
    [ANIMATION_SUBTYPES.TYPEWRITING_FIXED_DURATION]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      typing_start: 0,
      typing_duration: 0.5
    }
  },
  [ANIMATIONS.TEXT_WAVE]: {
    [ANIMATION_SUBTYPES.LINE_BY_LINE]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "line",
      overlap: "50%"
    },
    [ANIMATION_SUBTYPES.WORD_BY_WORD]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "word",
      overlap: "50%"
    },
    [ANIMATION_SUBTYPES.LETTER_BY_LETTER]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter",
      overlap: "50%"
    },
    [ANIMATION_SUBTYPES.LETTER_BY_LETTER_RANDOMLY]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter",
      order: "random"
    },
    [ANIMATION_SUBTYPES.LETTER_BY_LETTER_ALTERNATIVE]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter",
      overlap: "90%",
      frequency: "1 Hz"
    },
    [ANIMATION_SUBTYPES.LONG_WAVELENGTH]: {
      time: 0,
      duration: 1,
      easing: "quadratic-out",
      split: "letter",
      overlap: "90%",
      frequency: "1 Hz",
      wavelength: "500%"
    }
  }
};

export const ANIMATION_CATEGORY = {
  [ANIMATIONS.SCALE]: "Options",
  [ANIMATIONS.SPIN]: "Rotation"
};
